import { Activity } from '../Activity/types';

export enum EducationLevelToText {
  HIGH_SCHOOL = 'High School',
  COLLEGE = 'College',
}

export enum WaitlistedReason {
  UNSUPPORTED_COUNTRY = 'UNSUPPORTED_COUNTRY',
  PLATFORM_ANDROID = 'PLATFORM_ANDROID',
}

export enum Theme {
  LIGHT = 'light',
  DARK = 'dark',
}

export type TBankVerficationStatus = 'verified' | 'pending' | 'expired';

export type AccountFlavor = 'student' | 'basic' | 'trading' | null;

export type EducationLevel = 'high_school' | 'college';

export type AcademicYear =
  | 'freshman'
  | 'sophomore'
  | 'junior'
  | 'senior';

export type StudentStatus = {
  institutions?: string[] | any[]
  email?: string
  createdAt?: number | string;
  verified?: TBankVerficationStatus;
  expiresAt?: Date | number;
  verificationId?: string;
  educationLevel?: EducationLevel;
  academicYear?: AcademicYear;
}

export interface Account {
  id?: string;
  activities?: Activity[];
  alpacaId?: string;
  birthday: string;
  created?: number;
  email: string;
  favoriteStock?: string;
  inviteCode?: string;
  name: string;
  firstName: string;
  lastName: string;
  freeStocks?: any[];
  notificationToken?: string;
  fcmToken?: string;
  pathway?: string;
  discord?: string;
  phoneNumber: string;
  bankOwner?: 'child' | 'parent';
  referredBy?: string;
  sponsorPhoneNumber?: string;
  sponsorId?: string;
  sponsorName?: string;
  bankVerificationStatus?: TBankVerficationStatus;
  parentInviteUrl?: string;
  sponsorEmail?: string;
  parentId?: string;
  verificationCode?: string;
  invitedSponsor?: boolean;
  invitedSponsorTimestamp?: number;
  lastCheckedActivityTimestamp?: number;
  completedSuitability?: boolean;
  waitlisted?: boolean;
  waitlistedReason?: WaitlistedReason;
  branchReferralLink?: string;
  groupId?: string;
  lastCheckedChangelogTimestamp?: number;
  theme?: Theme;
  flavor?: AccountFlavor;
  isStudent?: boolean;
  studentStatus?: StudentStatus;
}

export enum ParentAccountStatus {
  UNDER_REVIEW = "UnderReview",
  ACTION_REQUIRED = "ActionRequired",
  APPROVED = "Approved",
  DECLINED = "Declined",
  ALL_SET = "AllSet"
}

export const ParentAccountStatusToText: { [key: string] : string } = {
  [ParentAccountStatus.UNDER_REVIEW]: "Under Review",
  [ParentAccountStatus.ACTION_REQUIRED]: "Action Required",
  [ParentAccountStatus.APPROVED]: "Approved",
  [ParentAccountStatus.DECLINED]: "Declined",
  [ParentAccountStatus.ALL_SET]: "All Set"
}

export enum RiskRatingRestriction {
  HIGH = 'high',
  MODERATE = 'moderate',
  MILD = 'mild',
  NONE = 'none',
}

export type TDepositMethod = 'debitCard' | 'bankAccount';

export enum BrokerageAccountType {
  Individual = 'individual',
  Custodial = 'custodial',
}

export interface Parent {
  accessToken: string;
  alpacaId: string;
  autoApproval: boolean;
  depositApproval: boolean;
  childId: string;
  email: string;
  firstName: string;
  lastName: string;
  createdAt?: number;
  isSponsor: boolean;
  linkedBank?: string;
  linkedDebitCard?: string;
  latestDepositMethod?: TDepositMethod;
  password: string;
  phoneNumber: string;
  status: ParentAccountStatus;
  bankVerificationStatus?: TBankVerficationStatus;
  plaidAccountId?: string;
  userId: string;
  bankOwner?: 'child' | 'parent';
  groupId?: string;
  // this flag, if true, does not let the user engage in any deposits
  incomingTransfersBlocked?: string;
  fcmToken?: string;
  receivedMicrodeposits?: boolean;
  scheduleScheduledDepositPromptShown?: boolean;
  queuedDebitCardDepositStatus?: string;
  queuedDebitCardDepositAmount?: number;
  subscriptionMode?: string;
  subscriptionAmount?: number;
  subscriptionCancelReason?: string[];
  attributionSource?: string;
  lastCheckedChangelogTimestamp?: number;
  brokerageAccountType?: BrokerageAccountType;
  skippedBrokerageAccount?: boolean;
  limitFundsForCryptosTo?: number;
  initialDeposit?: boolean;
  riskRatingRestriction?: RiskRatingRestriction;
  
}
